import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import useCustomStyles from '../../hooks/CustomStylesHook'
import { Grid2 as Grid, useTheme } from '@mui/material'
import BasicDetails from './basicDetails/BasicDetails'
import ApproveReject from './approveReject/ApproveReject'
import ProposerDeclaration from './proposerDeclaration/ProposerDeclaration'
import PhysicalTests from './physicalTests/PhysicalTests'
import LabTests from './labTests/LabTests'

const styles = (theme: any) => ({
  tabsContainer: {
    height: '5%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  tabSelected: {
    background: `${theme.palette.primary.main} !important`,
    borderRadius: '20px !important',
    transition: 'background-color 0.3s',
    color: '#FFFFFF !important',
    fontSize: '14px !important',
    minHeight: 'unset',
    textTransform: 'capitalize',
  },
  tabUnSelected: {
    color: '#6C6C6C !important',
    fontSize: '14px !important',
    minHeight: 'unset',
    textTransform: 'capitalize',
  },
  tabContentContainer: {
    flex: 1,
    overflowY: 'auto',
  },
})

const CustomerDetailTabs = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const tabs = [
    'Basic Details',
    'Proposer / Declaration',
    'Lab Tests',
    'Physical Tests',
    'Approve / Reject',
  ]
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const RenderTab = ({ tabValue }: { tabValue: number }) => {
    switch (tabValue) {
      case 0:
        return <BasicDetails />
      case 1:
        return <ProposerDeclaration />
      case 2:
        return <LabTests />
      case 3:
        return <PhysicalTests />
      case 4:
        return <ApproveReject />

      default:
        return null
    }
  }

  return (
    <Grid
      container
      direction={'column'}
      spacing={1.5}
      // pb={8}
      // pr={2}
      height={'100%'}
    >
      <Grid
        display={'flex'}
        justifyContent={'center'}
        size={{ xs: 12 }}
        position={'sticky'}
        top={0}
        zIndex={1}
      >
        <Box maxWidth={{ xs: 320, sm: 445, xl: 800, md: 500 }}>
          <Tabs
            TabIndicatorProps={{
              style: { display: 'none' },
            }}
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
            aria-label='scrollable auto tabs example'
          >
            {tabs?.map((label, index) => (
              <Tab
                key={label}
                label={label}
                className={
                  value === index
                    ? classes?.tabSelected
                    : classes?.tabUnSelected
                }
              />
            ))}
          </Tabs>
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }} pr={2} className={classes?.tabContentContainer}>
        <RenderTab tabValue={value} />
      </Grid>
    </Grid>
  )
}

export default CustomerDetailTabs
